export default [
  {
    path: '/manual',
    meta: {
      title: '住院手册'
    },
    component: () => import('../pages/manual/index.vue')
  },
  {
    path: '/manual/time',
    meta: {
      title: '作息时间'
    },
    component: () => import('../pages/manual/time.vue')
  },
  {
    path: '/manual/ordering',
    meta: {
      title: '订餐制度'
    },
    component: () => import('../pages/manual/ordering.vue')
  },
  {
    path: '/manual/accompanying',
    meta: {
      title: '陪住制度'
    },
    component: () => import('../pages/manual/accompanying.vue')
  },
  {
    path: '/manual/ward',
    meta: {
      title: '病房管理制度'
    },
    component: () => import('../pages/manual/ward.vue')
  }
]


// WEBPACK FOOTER //
// ./src/router/manual.js